import { parseJSON } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { isDate, isNumber, isString } from "lodash-es";

import { getLocalTimeZone } from "../dates";
import isValidDate from "../isValidDate";

const parseDate = (date: Date | number | string): Date => {
  if (isDate(date)) {
    return new Date(date.getTime());
  }

  if (isNumber(date)) {
    return new Date(date);
  }

  if (isString(date)) {
    return parseJSON(date);
  }

  return new Date(NaN);
};

export const parseApiDate = (date: Date | number | string): Date => {
  if (typeof date === "string" && date.length === 10) {
    date = `${date}T00:00:00Z`;
  }
  return parseDate(date);
};

export const parseApiDateAsNumber = (date: Date | number | string): number => {
  const result = parseDate(date);
  return isValidDate(result) ? result.getTime() : 0;
};

export const parseApiDateWithTz = (date: Date | number | string, timeZone?: string): Date => {
  if (!date) {
    return new Date(Number.NaN); // Invalid Date
  }
  return toZonedTime(date, timeZone ?? getLocalTimeZone());
};

export const parseApiDateWithUtcTz = (date: Date | number | string): Date => {
  if (!date) {
    return new Date(Number.NaN); // Invalid Date
  }
  return parseApiDateWithTz(date, "UTC");
};
